import React from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import PageContainer from "views/PageContainer";
import LoadingContainer from "views/Loading/LoadingContainer";
import LoginContainer from "views/Login/LoginContainer";
import NotFoundContainer from "views/NotFound/NotFoundContainer";
import TosContainer from "views/Tos/TosContainer";
import SignUpView from "views/Login/SignUpView";
import MonitorModeView from "views/MonitorMode/MonitorModeView";
import { NOT_FOUND } from "redux-first-router";

import { get, isNil } from "lodash";
import { useSetFeatureFlagUser } from "../src/featureFlag";

const BlumiraApp = (props) => {
  useSetFeatureFlagUser(props.user, props.organization);

  switch (props.pageType) {
    case "LOGIN":
      return <LoginContainer />;
    case "SIGNUP":
      return <SignUpView />;
    case "PAGE":
      return <PageContainer />;
    case "TOS":
      return <TosContainer />;
    case `${NOT_FOUND}`:
      return <NotFoundContainer />;
    case "MONITORMODE":
      return <MonitorModeView />;
    default:
      return <LoadingContainer />;
  }
};

const mapStateToProps = (state) => {
  let currentOrg = {};

  // get currentOrgId from page payload
  const currentOrgId = get(state, ["page", "payload", "orgId"], null);

  // get list of userOrgs from session
  const currentUserOrgs = get(state, ["session", "settings", "userOrgs"], []);

  // if we have a current org id, find org data
  if (currentOrgId)
    currentOrg = currentUserOrgs.find(({ id }) => id === currentOrgId);

  // get user data from session
  const currentUser = get(state, ["session", "settings", "user"], null);

  const pageType =
    !isNil(currentUser) && !currentUser.acceptedTos
      ? "TOS"
      : state.location.type;

  return {
    user: currentUser,
    pageType: pageType,
    organization: currentOrg,
  };
};

export default hot(module)(connect(mapStateToProps)(BlumiraApp));
